import { render, staticRenderFns } from "./active.vue?vue&type=template&id=7b3dee9f&"
import script from "./active.vue?vue&type=script&lang=ts&"
export * from "./active.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports